'use client';

import { c as _c } from "react/compiler-runtime";
import { type FundingMethod, fundingMethodArtwork } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Badge } from '@/components/ui/app-badge';
import { ArrowRight01Icon } from '@/components/ui/icon/glyphs';
import { useFundingMethodLabels } from '../shared/funding-method-presentation';
export function FundingMethodRow(t0) {
  const $ = _c(13);
  const {
    method,
    subtitle,
    lowKyc: t1,
    onSelect
  } = t0;
  const lowKyc = t1 === undefined ? false : t1;
  const labels = useFundingMethodLabels();
  const t = useTranslations("onramp");
  const t2 = labels[method];
  let t3;
  if ($[0] !== lowKyc || $[1] !== method || $[2] !== t) {
    t3 = lowKyc && (method === "apple_pay" || method === "google_pay") ? t("low_kyc") : undefined;
    $[0] = lowKyc;
    $[1] = method;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `/assets/onramp/method-${fundingMethodArtwork[method]}.png`;
  let t5;
  if ($[4] !== method || $[5] !== onSelect) {
    t5 = onSelect ? {
      onSelect: () => onSelect(method)
    } : {};
    $[4] = method;
    $[5] = onSelect;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== subtitle || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <FundingOptionRow label={t2} subtitle={subtitle} badge={t3} artwork={t4} {...t5} />;
    $[7] = subtitle;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export function FundingOptionRow(t0) {
  const $ = _c(20);
  const {
    label,
    artwork,
    subtitle,
    badge,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== artwork) {
    t1 = <OptimizedImage nsfw={false} variant="thumbnail" preview={false} loadReveal="none" priority={true} rounded="" imageClassName="object-contain" src={artwork} alt="" size="size-10" className="bg-transparent" />;
    $[0] = artwork;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <span className="text-body font-medium">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== badge) {
    t3 = badge ? <Badge className="shrink-0 h-4 px-1.5 text-micro border-0 bg-feedback-success-accent/10 text-feedback-success-content">{badge}</Badge> : null;
    $[4] = badge;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <span className="flex items-center gap-2">{t2}{t3}</span>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== subtitle) {
    t5 = <span className="text-caption text-foreground-secondary">{subtitle}</span>;
    $[9] = subtitle;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <span className="flex flex-col items-start">{t4}{t5}</span>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <span className="flex items-center gap-3">{t1}{t6}</span>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const content = t7;
  let t8;
  if ($[17] !== content || $[18] !== onSelect) {
    t8 = onSelect ? <AnimatedButton variant="tertiary" suffix={ArrowRight01Icon} className="h-auto min-h-16.5 w-full justify-between rounded-control p-3" onClick={() => onSelect()}>{content}</AnimatedButton> : <div className="flex min-h-16.5 items-center p-3 opacity-60">{content}</div>;
    $[17] = content;
    $[18] = onSelect;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}